import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createLicenseApplication } from "../api/licenseApplicationApi";
import { licenseApplicationKeys } from "../api/licenseApplicationKeys";

export const useRegisterLicenseApplication = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createLicenseApplication,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: licenseApplicationKeys.list() });
      queryClient.invalidateQueries({ queryKey: licenseApplicationKeys.vacationDays() });
    },
  });
};
